import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useDeletePermissionTags as baseUseDeletePermissionTags } from '@vlabs/api/artemy/client';

import { confirmDeletePermissionTags } from './confirm/confirmDeletePermissionTags';
import type { PermissionTag } from '@vlabs/api/artemy/model';

interface UseDeletePermissionTagsProps {
  permissionTags: PermissionTag[];
}

type UseDeletePermissionTagsReturn = (() => Promise<void>);

export function useDeletePermissionTags({
  permissionTags,
}: UseDeletePermissionTagsProps): UseDeletePermissionTagsReturn {
  const { t } = useTranslation();
  const deletePermissionTag = baseUseDeletePermissionTags();

  return async (): Promise<void> => new Promise((resolve, reject) => {
    confirmDeletePermissionTags({
      onConfirm: () => {
        deletePermissionTag.mutateAsync({
          data: { permission_tags: permissionTags },
        }, {
          onSuccess: () => {
            toast.success(t('features:delete_permission_tags.toast.success'));
            resolve();
          },
          onError: () => {
            toast.error(t('features:delete_permission_tags.toast.error'));
            reject();
          },
        });
      },
      onReject: reject,
    });
  });
}
